import React from 'react';
import {
  TextField,
  FormField,
  formFieldRequiredLabel as requiredLabel,
  PasswordField,
} from '@elementary/common-ui/components';
import { useFormContext } from 'react-hook-form';
import SshTunnelFormSection from './SshTunnelFormSection';

const RedshiftFormContent = ({ disabled }: { disabled?: boolean }) => {
  const methods = useFormContext();
  const {
    register,
    formState: { errors, dirtyFields },
  } = methods;

  return (
    <>
      <FormField
        title="Host"
        errorMessage={errors.redshiftHost?.message as string}
      >
        <TextField
          {...register('redshiftHost', {
            required: requiredLabel,
          })}
          variant="outlined"
          placeholder="e.g. hostname.region.redshift.amazonaws.com"
          disabled={disabled}
          size="large"
        />
      </FormField>
      <FormField
        title="Port"
        errorMessage={errors.redshiftPort?.message as string}
      >
        <TextField
          {...register('redshiftPort', {
            required: requiredLabel,
          })}
          variant="outlined"
          placeholder="5439"
          defaultValue="5439"
          disabled={disabled}
          size="large"
        />
      </FormField>
      <FormField
        title="User"
        errorMessage={errors.redshiftUsername?.message as string}
      >
        <TextField
          {...register('redshiftUsername', {
            required: requiredLabel,
          })}
          variant="outlined"
          placeholder="e.g. elementary_user"
          disabled={disabled}
          size="large"
        />
      </FormField>
      <FormField
        title="Password"
        errorMessage={errors.redshiftPassword?.message as string}
      >
        <PasswordField
          {...register('redshiftPassword', {
            required: requiredLabel,
          })}
          isFormValueDirty={dirtyFields.redshiftPassword}
          clearFormValue={() => methods.setValue('redshiftPassword', '')}
          placeholder="Password"
          disabled={disabled}
          size="large"
        />
      </FormField>
      <SshTunnelFormSection disabled={disabled} />
    </>
  );
};

export default RedshiftFormContent;
